import { render, staticRenderFns } from "./mainTaskStayByCreateRoleTime.vue?vue&type=template&id=0004ef8b&"
import script from "./mainTaskStayByCreateRoleTime.vue?vue&type=script&lang=js&"
export * from "./mainTaskStayByCreateRoleTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0004ef8b')) {
      api.createRecord('0004ef8b', component.options)
    } else {
      api.reload('0004ef8b', component.options)
    }
    module.hot.accept("./mainTaskStayByCreateRoleTime.vue?vue&type=template&id=0004ef8b&", function () {
      api.rerender('0004ef8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/actionAnalysis/mainTaskStayByCreateRoleTime.vue"
export default component.exports